type DeepReadonly<T> = {
  readonly [P in keyof T]: T[P] extends object
    ? T[P] extends (...args: unknown[]) => unknown
      ? T[P]
      : DeepReadonly<T[P]>
    : T[P];
};

const deepFreeze = <T extends object>(object: T): DeepReadonly<T> => {
  const properties = Object.getOwnPropertyNames(object);

  for (const name of properties) {
    const value = (object as Record<string, unknown>)[name];

    value &&
      typeof value === 'object' &&
      !Object.isFrozen(value) &&
      deepFreeze(value);
  }

  return Object.freeze(object);
};

export default deepFreeze;
